import React from "react";
import NotificationsActiveRoundedIcon from "@material-ui/icons/NotificationsActiveRounded";
import { Badge, Menu, Tooltip } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import "./NotificationPanel.less";
import { DeleteOutlineOutlined, VisibilityOutlined } from "@material-ui/icons";
import { connect } from "react-redux";
import { getNotificationMasterData } from "../../../store/layout/actions";
import { API_URL } from "../../../constants/api";
import {
  getCommunicationNotificationData,
  NOTIFICATION_TYPE
} from "../../../utils/helper";
import { routes } from "../../../constants/routes";
import ConfirmDialog from "../Dailogbox/ConfirmDailog";
import { apiDelete, apiPut } from "../../../utils/api_service";
import { ShowToast, toastType } from "../../../utils/toast-service";
import { convertToLocalDate } from "../../../utils/date";

/**
 * Notification Container
 */
class NotificationContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pendingNotifications: props.pendingNotifications || [],
      isMenuOpen: false,
      reload: false
    };
  }

  componentDidMount() {
    if (
      this.props?.pendingNotifications === undefined ||
      this.props.pendingNotifications.length === 0
    ) {
      this.props.onGetNotificationMaster();
    }
    //setInterval(()=>this.props.onGetNotificationMaster(),)
  }

  /**
   * Get Derived State from Props
   * @param {*} newProps
   * @param {*} state
   * @returns
   */
  // static getDerivedStateFromProps(newProps, state) {
  //     if (newProps.pendingNotifications !== (state || {}).pendingNotifications ||
  //         newProps.pendingNotifications?.length !== (state || {}).pendingNotifications?.length ||
  //         newProps.reload !== (state || {}).reload) {
  //         return {
  //             pendingNotifications: newProps.pendingNotifications,
  //             reload: newProps.reload
  //         };
  //     }
  //     else {
  //         return state;
  //     }
  // }

  componentDidUpdate(prevProps) {
    if (this.props.reload != prevProps.reload) {
      this.setState({ pendingNotifications: this.props.pendingNotifications });
    }
  }

  /** */
  handleNotification = event => {
    this.setState({ isMenuOpen: true, anchorEl: event.currentTarget });
  };

  handleNotifyClose = () => {
    this.setState({
      item: undefined,
      action: undefined,
      type: undefined,
      showWarningMessage: false,
      isMenuOpen: false,
      confirmMessage: ""
    });
    this.props.onGetNotificationMaster();
  };

  clearArray = () => {
    // setPendingNotifications([]);
    // readAllNotification('Delete', true);
  };

  /** call on click */
  handelClick = async (item, type, action) => {
    const IsInEditMode = localStorage.getItem("IsInEditMode");
    if (IsInEditMode == 1 && action === "show") {
      this.setState({
        item,
        action,
        type,
        showWarningMessage: true,
        isMenuOpen: false,
        confirmMessage:
          window.location.href.indexOf("communication") > 0 ? (
            <>
              <p>
                {"Are you sure you want to leave this page without sending your\r"}
                {"Communication?\r"}
              </p>{" "}
            </>
          ) : (
            <>
              <p>
                {"Are you sure you want to leave this page without submitting your\r"}
                {"changes?\r"}
              </p>{" "}
            </>
          )
      });
    } else {
      await this.navigateToRecord(item, action, type);
    }
  };

  /** onclick handler */
  onClickHandel = isValid => {
    if (isValid) {
      localStorage.setItem("IsInEditMode", 0);
      this.navigateToRecord(
        this.state.item,
        this.state.action,
        this.state.type
      );
    }
    this.setState({ showWarningMessage: false });
  };

  /** Render notification */
  renderNotification = pendingNotifications => {
    return pendingNotifications.map((item, i) => (
      <tr
        key={"msg" + i}
        className={item.isRead === true ? "read-msg" : "unread-msg"}
      >
        <td
          className={" msg-body underline"}
          onClick={() => {
            this.handelClick(item, "view", "show");
          }}
        >
          {item.title}
        </td>
        <td
          className={" msg-body msg-content"}
          style={{ width: 208 }}
          dangerouslySetInnerHTML={{ __html: item.message }}
        />
        <td className={" msg-body"}>
          {convertToLocalDate(item.createdOn, "MM/DD/YYYY hh:mm A")}
        </td>

        <td className={" msg-body action"}>
          <div className={"menu-icon"}>
            <Tooltip title={"View notification"}>
              <VisibilityOutlined
                onClick={() => {
                  this.handelClick(item, "view", "show");
                }}
              />
            </Tooltip>
            {/* {item.isRead === false
                            ? <Tooltip title={"Mark as Read"}>
                                <MarkunreadOutlined onClick={() => { this.handelClick(item, 'read') }}></MarkunreadOutlined></Tooltip>
                            : <Tooltip title={"Mark as Unread"}><DraftsOutlined onClick={() => { this.handelClick(item, 'unread') }}></DraftsOutlined></Tooltip>
                        }
                        <Tooltip title={"Reply"}><Reply onClick={() => { this.handelClick(item, 'reply', 'show') }}></Reply></Tooltip>
                         */}
            <Tooltip title={"Delete notification"}>
              <DeleteOutlineOutlined
                onClick={() => {
                  this.handelClick(item, "delete");
                }}
              />
            </Tooltip>
          </div>
        </td>
      </tr>
    ));
  };

  /** Navigation for records */
  async navigateToRecord(item, action, type) {
    if (
      item.notificationType == NOTIFICATION_TYPE.Communication &&
      action === "show"
    ) {
      const data = await getCommunicationNotificationData(item, type);

      this.props.history.push({
        pathname: routes.communication,
        notificationProps: {
          isOpenCommunication: true,
          isViewOnly: true,
          isReply: type === "reply",
          content: data.content,
          mainContent: data.mainContent,
          recordId: item.recordId
        }
      });

      this.handleNotifyClose();
    } else if (
      item.notificationType == NOTIFICATION_TYPE.Request &&
      action === "show"
    ) {
      this.props.history.push({
        pathname: routes.requests,
        notificationProps: {
          isOpenRequest: true,
          isViewOnly: true,
          isReply: type === "reply",
          recordId: item.recordId,
          message: item.message,
          createdOn: item.createdOn
        }
      });

      this.handleNotifyClose();
    }
    else if (
      item.notificationType == NOTIFICATION_TYPE.SecurityIncident &&
      action === "show"
    ) {
      this.props.history.push({
        pathname: routes.securityIncident,
        notificationProps: {
          isOpenRequest: true,
          isViewOnly: true,
          isReply: type === "reply",
          recordId: item.recordId,
          message: item.message,
          createdOn: item.createdOn
        }
      });

      this.handleNotifyClose();
    }
    if (type !== "delete") {
      this.UpdateNotification(
        item.notificationId,
        type === "unread" ? type : "read",
        false
      );
    } else {
      this.deleteNotification(item.notificationId, false);
    }
    // this.props.onGetNotificationMaster();
  }

  /** Update notification */
  UpdateNotification(notificationId, type, all = false) {
    apiPut({
      url: `${API_URL.Notification.Put}?id=${notificationId}&all=${all}&type=${type}`
    }).then(({ data: response }) => {
      if (response.success !== true) {
        ShowToast(response.message, toastType.ERROR, 5000, 5000);
      } else {
        const { reload } = this.state;
        this.setState(
          { pendingNotifications: response.data, reload: !reload },
          () => {
            this.forceUpdate();
          }
        );
      }
    });
  }

  /** Delete Notification */
  deleteNotification(notificationId, all = false) {
    apiDelete(
      {
        url: `${API_URL.Notification.Delete}?id=${notificationId}&all=${all}`
      },
      true
    ).then(({ data: response }) => {
      if (response.success !== true) {
        ShowToast(response.message, toastType.ERROR, 5000, 5000);
      } else {
        const {reload} =this.state;
        this.setState(
          { pendingNotifications: response.data, reload: !reload },
          () => {
            this.forceUpdate();
          }
        );
      }
    });
  }

  render() {
    const { isMenuOpen, anchorEl, pendingNotifications } = this.state;
    let notificationCount = (
      pendingNotifications?.filter(x => x.isRead === false) || []
    ).length;
    notificationCount = notificationCount > 99 ? "99+" : notificationCount;
    return (
      <>
        <div className={"action-item"}>
          <Badge
            badgeContent={notificationCount || 0}
            color={"secondary"}
            size={"medium"}
            onClick={this.handleNotification}
            style={{ cursor: "pointer" }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left"
            }}
            overlap={"rectangular"}
          >
            <NotificationsActiveRoundedIcon />
          </Badge>
        </div>
        <Menu
          id={"simple-menu"}
          anchorEl={anchorEl}
          keepMounted
          open={isMenuOpen}
          onClose={this.handleNotifyClose}
          className={"notification-menu"}
        >
          <div className={"notification-message-container"}>
            <div className={"row"}>
              <div className={"col-xs-12 row-header"}>{"Notification List"}</div>
            </div>
            <table className={"msg-com"}>
              <tbody>
                {this.renderNotification(pendingNotifications || [])}
              </tbody>
            </table>
            {(pendingNotifications?.length || 0) === 0 && (
              <div style={{ padding: 10, textAlign: "center" }}>
                {"No Pending Notifications\r"}
              </div>
            )}
          </div>
        </Menu>

        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={isValid => {
              if (isValid) {
                this.onClickHandel(isValid);
              } else {
                this.onClickHandel(isValid);
              }
            }}
            AgreeText={"Yes"}
            DisAgreeText={"No"}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    pendingNotifications: state?.layoutConfig?.notificationData,
    reload: state?.layoutConfig?.reload
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetNotificationMaster: () => dispatch(getNotificationMasterData())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NotificationContainer));
